import { Link } from 'react-router-dom';
import { articles } from '@/mocks/categories';

export default function ArticlePreviewSection() {
  const featuredArticle = articles[0];

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-10 max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            Featured <strong className="text-primary-600">Pandabuy Sheet</strong> Guide
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            Start with our most comprehensive guide to master the pandabuyspreadsheet ecosystem
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Link
            to={`/article/${featuredArticle.slug}`}
            className="group block bg-background-100 border border-background-200/70 rounded-2xl overflow-hidden hover:border-primary-300 hover:shadow-sm transition-all duration-300 cursor-pointer"
          >
            <div className="flex flex-col md:flex-row">
              <div className="md:w-2/5 h-48 md:h-auto overflow-hidden">
                <img
                  src={featuredArticle.image}
                  alt={featuredArticle.title}
                  title={featuredArticle.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="md:w-3/5 p-6 md:p-8 flex flex-col justify-center">
                <span className="inline-flex items-center gap-1.5 text-xs font-medium text-accent-700 bg-accent-100 rounded-full px-3 py-1 w-fit mb-3 font-label">
                  <i className="ri-guide-line"></i> {featuredArticle.tag}
                </span>
                <h3 className="text-lg md:text-xl font-heading text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors duration-200">
                  {featuredArticle.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {featuredArticle.description}
                </p>
                <div className="flex items-center gap-3">
                  <span className="text-xs text-foreground-400 font-label flex items-center gap-1">
                    <i className="ri-time-line"></i> {featuredArticle.readTime}
                  </span>
                  <span className="inline-flex items-center gap-1.5 text-sm font-semibold font-label text-primary-600 group-hover:gap-2.5 transition-all duration-200 whitespace-nowrap">
                    Read Full Article <i className="ri-arrow-right-line text-base"></i>
                  </span>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}